import React from "react";
type Props = { className?: string };

export const UsersIcon = ({ className }: Props) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M1.24383 11.9098C2.01898 11.1347 3.07031 10.6992 4.16654 10.6992H10.8332C11.9294 10.6992 12.9808 11.1347 13.7559 11.9098C14.5311 12.685 14.9665 13.7363 14.9665 14.8326V16.4992C14.9665 16.941 14.6084 17.2992 14.1665 17.2992C13.7247 17.2992 13.3665 16.941 13.3665 16.4992V14.8326C13.3665 14.1607 13.0996 13.5163 12.6245 13.0412C12.1494 12.5661 11.5051 12.2992 10.8332 12.2992H4.16654C3.49466 12.2992 2.85029 12.5661 2.3752 13.0412C1.90011 13.5163 1.6332 14.1607 1.6332 14.8326V16.4992C1.6332 16.941 1.27503 17.2992 0.833203 17.2992C0.391375 17.2992 0.0332031 16.941 0.0332031 16.4992V14.8326C0.0332031 13.7363 0.468678 12.685 1.24383 11.9098Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M7.49987 2.29922C6.10075 2.29922 4.96654 3.43343 4.96654 4.83255C4.96654 6.23167 6.10075 7.36589 7.49987 7.36589C8.89899 7.36589 10.0332 6.23167 10.0332 4.83255C10.0332 3.43343 8.89899 2.29922 7.49987 2.29922ZM3.36654 4.83255C3.36654 2.54978 5.21709 0.699219 7.49987 0.699219C9.78265 0.699219 11.6332 2.54978 11.6332 4.83255C11.6332 7.11533 9.78265 8.96589 7.49987 8.96589C5.21709 8.96589 3.36654 7.11533 3.36654 4.83255Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15.8919 11.4066C16.0024 10.9788 16.4387 10.7216 16.8665 10.832C17.7532 11.061 18.5388 11.578 19.0999 12.3018C19.661 13.0256 19.9658 13.9152 19.9665 14.831V16.4983C19.9665 16.9401 19.6083 17.2983 19.1665 17.2983C18.7247 17.2983 18.3665 16.9401 18.3665 16.4983V14.8319C18.366 14.2707 18.1792 13.7256 17.8354 13.282C17.4915 12.8384 17.01 12.5216 16.4665 12.3812C16.0387 12.2708 15.7814 11.8344 15.8919 11.4066Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.5582 1.40821C12.6678 0.980189 13.1037 0.72205 13.5317 0.831641C14.4208 1.05929 15.2088 1.57637 15.7716 2.30136C16.3343 3.02636 16.6398 3.91803 16.6398 4.83581C16.6398 5.75358 16.3343 6.64526 15.7716 7.37025C15.2088 8.09525 14.4208 8.61233 13.5317 8.83997C13.1037 8.94956 12.6678 8.69143 12.5582 8.26341C12.4487 7.83538 12.7068 7.39956 13.1348 7.28997C13.6797 7.15045 14.1627 6.83353 14.5077 6.38918C14.8526 5.94482 15.0398 5.39831 15.0398 4.83581C15.0398 4.2733 14.8526 3.72679 14.5077 3.28244C14.1627 2.83808 13.6797 2.52116 13.1348 2.38164C12.7068 2.27205 12.4487 1.83623 12.5582 1.40821Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
